// extracted by mini-css-extract-plugin
module.exports = {"requestBox":"style_request-box__G1Zs0","mainAdornment":"style_main-adornment__VXyUB","mainImage":"style_main-image__kGg8u","imageAdornment":"style_image-adornment__wlljF"};